// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + {"4346":"5493da1b","5950":"63b94182"}[chunkId] + "." + {"4346":"ba06bf018e8c9727","5950":"17844ec12a6a2a4e"}[chunkId] + ".js";
};